/**
 * Smart-merge a default search (page-level scope, e.g. tenantId + year) with
 * an active omnisearch string. Mirrors the same merge done inside
 * `OmnisearchDataDisplay`: a key in `omnisearch` always wins over the same
 * key in `defaultSearch`, preventing duplicate filters from arriving at the
 * backend as `tenantId:abc tenantId:abc`.
 *
 * This is exposed as a module-level helper (not a hook) so that
 * `ManifestStatsCardsConnected` and any other consumers can reuse it without
 * tripping the `react-refresh/only-export-components` lint rule on the
 * component file.
 */
export function mergeDefaultAndOmnisearch(defaultSearch: string, omnisearch: string): string {
  const def = defaultSearch.trim();
  const om = omnisearch.trim();
  if (!om) return def;
  if (!def) return om;

  const omKeys = new Set<string>();
  const keyRegex = /([^:\s]+):/g;
  let match: RegExpExecArray | null;
  while ((match = keyRegex.exec(om)) !== null) {
    omKeys.add(match[1]);
  }

  const tokens = def.split(/\s+/).filter(Boolean);
  const filtered = tokens.filter((token) => {
    const colonIdx = token.indexOf(":");
    if (colonIdx <= 0) return true;
    const key = token.substring(0, colonIdx);
    return !omKeys.has(key);
  });
  return [filtered.join(" "), om].filter(Boolean).join(" ").trim();
}
